module.exports = function(bootstrap) {
    bootstrap.run(["Service", function (Service) {
        return new Service({
            name: 'ebill',
            group: "eprsvc",
            url: "/eprsvc/x-services/secure/ebill/v1/",
            cache: true,
            getBillingAccounts: function(userName){

                this.url="/eprsvc/x-services/secure/ebill/v1/accounts/"+userName;
                return this.get();

            },
            flushBillingAccounts: function(userName){
                this.url="/eprsvc/x-services/secure/ebill/v1/accounts/"+userName;
                return this.flushCache();

            },
            removeAccountFromUser: function(userName,accountNumber){
                this.url="/eprsvc/x-services/secure/ebill/v1/accounts/"+userName+"/"+accountNumber;
                return this.post();
            },
            getUserTypes: function(userName,accountNumber){
                this.url="/eprsvc/x-services/secure/ebill/v1/userTypes/"+userName+"/"+accountNumber;
                return this.get();
            },
            flushUserTypes: function(userName,accountNumber){
                this.url="/eprsvc/x-services/secure/ebill/v1/userTypes/"+userName+"/"+accountNumber;
                return this.flushCahce();
            },
            addBillingAccount: function(userName,accountNumber,userTypes){
                this.url="/eprsvc/x-services/secure/ebill/v1/accounts/"+userName+"/"+accountNumber+"/"+userTypes;
                return this.put();
            }
        });
    }]);
};
